import Landing from "../Components/Login/Landing";

const LandingPage = () => {
  return <Landing />;
};

export default LandingPage;
